import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ArrowRight } from "@phosphor-icons/react";

/**
 * HeaderV2 — sticky con glassmorphism. CTA "Prova gratis" in primo
 * piano (al posto di "Accedi") quando l'utente NON è loggato.
 *
 * iter v31 r48 — User: «se gliele lasciamo scritte in alto senza un menu
 * che si apre?». Drawer hamburger sostituito da una seconda riga di nav
 * sempre visibile su mobile (md:hidden). Su desktop resta inline.
 */

const NAV_LINKS = [
  { href: "/come-funziona", label: "Come funziona", testid: "nav-come-funziona" },
  { href: "/#feature-foto", label: "Esempi", testid: "nav-esempi" },
  { href: "/#pricing", label: "Prezzi", testid: "nav-pricing" },
  { href: "/#faq", label: "FAQ", testid: "nav-faq" },
];

export default function HeaderV2() {
  const navigate = useNavigate();
  const { user } = useAuth();
  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#FAFAF7]/85 border-b border-[#1C1C1A]/5"
      data-testid="navbar"
    >
      <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-10">
        {/* Riga 1 — logo + nav desktop + CTA */}
        <div className="h-16 sm:h-18 flex items-center justify-between">
          <a
            href="/"
            className="relative inline-flex items-center"
            data-testid="brand-link-landing"
          >
            <img
              src="/logo/pronto-app-square-2026-tight.jpg"
              alt="Pronto"
              className="h-11 w-11 sm:h-12 sm:w-12 rounded-lg select-none"
              draggable="false"
            />
          </a>

          {/* Nav desktop inline */}
          <nav
            className="hidden md:flex items-center gap-7 text-[13.5px] text-[#1C1C1A]"
            aria-label="Principale"
          >
            {NAV_LINKS.map((l) => (
              <a
                key={l.testid}
                href={l.href}
                className="hover:text-[#7C8B6E] transition-colors"
                data-testid={l.testid}
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3">
            {user ? (
              <button
                onClick={() => navigate("/dashboard")}
                className="inline-flex items-center gap-1.5 bg-[#1C1C1A] hover:bg-black text-white px-4 py-2 rounded-lg font-semibold text-[13px] transition-colors"
                data-testid="header-dashboard-btn"
              >
                Dashboard
                <ArrowRight size={14} weight="bold" />
              </button>
            ) : (
              <>
                <button
                  onClick={() => navigate("/login")}
                  className="text-[#1C1C1A] hover:text-[#7C8B6E] text-[13.5px] font-medium px-2 transition-colors"
                  data-testid="header-login-btn"
                >
                  Accedi
                </button>
                <button
                  onClick={() => navigate("/register")}
                  className="inline-flex items-center gap-1.5 bg-[#1C1C1A] hover:bg-black text-white px-3 sm:px-4 py-2 rounded-lg font-semibold text-[12.5px] sm:text-[13px] shadow-[0_4px_14px_rgba(28,28,26,0.18)] hover:shadow-[0_6px_20px_rgba(28,28,26,0.24)] transition-all active:scale-[0.98]"
                  data-testid="header-register-btn"
                >
                  Prova gratis
                  <ArrowRight size={14} weight="bold" />
                </button>
              </>
            )}
          </div>
        </div>

        {/* Riga 2 — nav mobile sempre visibile sotto, inline e centrata.
            Su desktop nascosta (nav è già nella riga 1). */}
        <nav
          className="md:hidden flex items-center justify-between gap-1 pb-2.5 -mt-0.5 text-[12.5px] text-[#3F3D38] overflow-x-auto"
          aria-label="Mobile principale"
        >
          {NAV_LINKS.map((l) => (
            <a
              key={`${l.testid}-mobile`}
              href={l.href}
              className="px-2 py-1 rounded-md hover:text-[#7C8B6E] hover:bg-[#1C1C1A]/5 transition-colors whitespace-nowrap"
              data-testid={`${l.testid}-mobile`}
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}
